/** Lets the command palette open the top bar's Personal Lockout panel without prop drilling. */
const EVENT = "helm:open-lockout";

export function openLockoutPanel(): void {
  window.dispatchEvent(new Event(EVENT));
}

export function onOpenLockoutPanel(cb: () => void): () => void {
  window.addEventListener(EVENT, cb);
  return () => {
    window.removeEventListener(EVENT, cb);
  };
}
